import {
  SmartSearchEntityType,
  SmartSearchTabs,
  SmartSearchTabsType,
} from '../../SmartSearch.types.js'

export const SEARCH_PAGE_QUERY_PARAMS = {
  QUERY: 'query',
  TAGS_ID: 'tagsId',
  TYPE: 'type',
  DATE: 'date',
  VIEW: 'view',
  SPACE_IDS: 'spaceIds',
}

export const SMART_SEARCH_DEFAULT_VALUES = {
  query: '',
  tagsId: [] as string[],
  type: null as SmartSearchEntityType | null,
  date: null,
  view: SmartSearchTabs.SEARCH as SmartSearchTabsType,
  spaceIds: [] as string[],
}
